import { PriorityGroup } from './PriorityGroup';
import type { ActionPriority, DecisionAction, LocalActionFlags } from './types';
import { PRIORITY_ORDER } from './types';

export function DecisionBoard({
  grouped,
  expanded,
  onTogglePriority,
  flags,
  onPin,
  onBookmark,
  onComplete,
  onDismiss,
  onRestore,
  filterPriority,
}: {
  grouped: Record<ActionPriority, DecisionAction[]>;
  expanded: Record<ActionPriority, boolean>;
  onTogglePriority: (p: ActionPriority) => void;
  flags: LocalActionFlags;
  onPin: (id: string) => void;
  onBookmark: (id: string) => void;
  onComplete: (id: string) => void;
  onDismiss: (id: string) => void;
  onRestore: (id: string) => void;
  filterPriority: ActionPriority | 'all';
}) {
  const sections =
    filterPriority === 'all'
      ? PRIORITY_ORDER
      : PRIORITY_ORDER.filter((p) => p === filterPriority);

  return (
    <div className="space-y-3" data-decision-board="COMMAND-CENTER-000001">
      {sections.map((priority) => (
        <PriorityGroup
          key={priority}
          priority={priority}
          actions={grouped[priority]}
          expanded={expanded[priority]}
          onToggle={() => onTogglePriority(priority)}
          flags={flags}
          onPin={onPin}
          onBookmark={onBookmark}
          onComplete={onComplete}
          onDismiss={onDismiss}
          onRestore={onRestore}
        />
      ))}
    </div>
  );
}
